import { render } from "./OnePagePdf.vue?vue&type=template&id=638d84b6&scoped=true&bindings={\"doc\":\"props\"}"
import script from "./OnePagePdf.vue?vue&type=script&lang=js"
export * from "./OnePagePdf.vue?vue&type=script&lang=js"

import "./OnePagePdf.vue?vue&type=style&index=0&id=638d84b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-638d84b6"

export default script